/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const deletePlayer = /* GraphQL */ `
  mutation DeletePlayer(
    $input: DeletePlayerInput!
    $condition: ModelPlayerConditionInput
  ) {
    deletePlayer(input: $input, condition: $condition) {
      id
      avatarPortrait
      subscriptionId
      paymentId
      avatar
      firstName
      lastName
      email
      bio
      dateOfBirth
      instagram
      tikTok
      twitter
      discord
      website
      toStake
      staked
      balance
      interests
      education
      achievements
      jobs
      blogsAndVideos
      createdAt
      updatedAt
    }
  }
`;
export const deleteSubscriptionHundo = /* GraphQL */ `
  mutation DeleteSubscriptionHundo(
    $input: DeleteSubscriptionHundoInput!
    $condition: ModelSubscriptionHundoConditionInput
  ) {
    deleteSubscriptionHundo(input: $input, condition: $condition) {
      id
      price
      chargeBeeId
      stripeId
      playerId
      email
      billingCyclesPerYear
      startTerm
      createdAt
      updatedAt
    }
  }
`;
export const deleteCourse = /* GraphQL */ `
  mutation DeleteCourse(
    $input: DeleteCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    deleteCourse(input: $input, condition: $condition) {
      id
      playerId
      scorePercentage
      progress
      passed
      courseId
      staked
      createdAt
      updatedAt
    }
  }
`;
export const deleteQuestion = /* GraphQL */ `
  mutation DeleteQuestion(
    $input: DeleteQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    deleteQuestion(input: $input, condition: $condition) {
      id
      playerId
      courseId
      moduleId
      questionId
      question
      answers
      createdAt
      updatedAt
    }
  }
`;
export const createPlayer = /* GraphQL */ `
  mutation CreatePlayer(
    $input: CreatePlayerInput!
    $condition: ModelPlayerConditionInput
  ) {
    createPlayer(input: $input, condition: $condition) {
      id
      avatarPortrait
      subscriptionId
      paymentId
      avatar
      firstName
      lastName
      email
      bio
      dateOfBirth
      instagram
      tikTok
      twitter
      discord
      website
      toStake
      staked
      balance
      interests
      education
      achievements
      jobs
      blogsAndVideos
      createdAt
      updatedAt
    }
  }
`;
export const updatePlayer = /* GraphQL */ `
  mutation UpdatePlayer(
    $input: UpdatePlayerInput!
    $condition: ModelPlayerConditionInput
  ) {
    updatePlayer(input: $input, condition: $condition) {
      id
      avatarPortrait
      subscriptionId
      paymentId
      avatar
      firstName
      lastName
      email
      bio
      dateOfBirth
      instagram
      tikTok
      twitter
      discord
      website
      toStake
      staked
      balance
      interests
      education
      achievements
      jobs
      blogsAndVideos
      createdAt
      updatedAt
    }
  }
`;
export const createSubscriptionHundo = /* GraphQL */ `
  mutation CreateSubscriptionHundo(
    $input: CreateSubscriptionHundoInput!
    $condition: ModelSubscriptionHundoConditionInput
  ) {
    createSubscriptionHundo(input: $input, condition: $condition) {
      id
      price
      chargeBeeId
      stripeId
      playerId
      email
      billingCyclesPerYear
      startTerm
      createdAt
      updatedAt
    }
  }
`;
export const updateSubscriptionHundo = /* GraphQL */ `
  mutation UpdateSubscriptionHundo(
    $input: UpdateSubscriptionHundoInput!
    $condition: ModelSubscriptionHundoConditionInput
  ) {
    updateSubscriptionHundo(input: $input, condition: $condition) {
      id
      price
      chargeBeeId
      stripeId
      playerId
      email
      billingCyclesPerYear
      startTerm
      createdAt
      updatedAt
    }
  }
`;
export const createCourse = /* GraphQL */ `
  mutation CreateCourse(
    $input: CreateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    createCourse(input: $input, condition: $condition) {
      id
      playerId
      scorePercentage
      progress
      passed
      courseId
      staked
      createdAt
      updatedAt
    }
  }
`;
export const updateCourse = /* GraphQL */ `
  mutation UpdateCourse(
    $input: UpdateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    updateCourse(input: $input, condition: $condition) {
      id
      playerId
      scorePercentage
      progress
      passed
      courseId
      staked
      createdAt
      updatedAt
    }
  }
`;
export const createQuestion = /* GraphQL */ `
  mutation CreateQuestion(
    $input: CreateQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    createQuestion(input: $input, condition: $condition) {
      id
      playerId
      courseId
      moduleId
      questionId
      question
      answers
      createdAt
      updatedAt
    }
  }
`;
export const updateQuestion = /* GraphQL */ `
  mutation UpdateQuestion(
    $input: UpdateQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    updateQuestion(input: $input, condition: $condition) {
      id
      playerId
      courseId
      moduleId
      questionId
      question
      answers
      createdAt
      updatedAt
    }
  }
`;
